module.exports = __webpack_public_path__ + "img/emo_11.435cf6d5.png";